/** The three-dot "dealer is typing" bubble shown while a chat message is pending. */
export function TypingIndicator() {
  return (
    <div
      className="sm-animate-in sm-chat-tail sm-chat-bubble sm-chat-typing"
      data-side="dealer"
      aria-label="Dealer is typing"
    >
      <span />
      <span />
      <span />
    </div>
  );
}
